import React from 'react'

import { useServiceOrders } from '../_load/ServiceOrdersLoader'
import ServiceOrdersListItem from './ServiceOrdersListItem'

const ServiceOrdersList = () => {
  const serviceOrders = useServiceOrders()

  return serviceOrders.map(item => <ServiceOrdersListItem key={item.id} item={item} />)
}

export default ServiceOrdersList
